import { TimePeriod } from 'controls/react/form/timePeriodSelector';

export enum MetricConfigurationUnitType {
	Autoscaling = 'AUTOSCALING',
	Custom = 'CUSTOM',
}

export type MetricConfiguration = {
	metricId: string;
	unit?: string;
	unitLabel?: string;
	decimals?: number;
	formula?: string;
	trendPeriod?: TimePeriod;
};
